module.exports = __webpack_public_path__ + "img/document.96226dc4.svg";